import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Checkbox,
  Divider,
  Grid2

} from "@mui/material";

import { mockUnidadesAtendimento, mockComoConheceuUBC, mockSociedadesUBC } from '../mock';
import limiteTamanhoCampos from '../limiteCampos';

const sociedades = mockSociedadesUBC();

const unidadesAtendimento = await mockUnidadesAtendimento();

const FormularioFiliacaoUBCPJ = forwardRef((props, ref) => {

  const listaComoConheceuUBC = mockComoConheceuUBC();

  const [formData, setFormData] = useState(
    {
      editor: props?.formData?.editor || false,
      territorioAdmAutorais: props?.formData?.territorioAdmAutorais || 2136,

      produtorFonograficoConexao: props?.formData?.produtorFonograficoConexao || false,
      territorioAdmConexao: props?.formData?.territorioAdmConexao || 2136,

      editorNaoFiliacao: props?.formData?.editorNaoFiliacao || false,
      produtorFonograficoNaoFiliacao: props?.formData?.produtorFonograficoNaoFiliacao || false,

      editorFiliado: props?.formData?.editorFiliado || false,
      produtorFonograficoFiliado: props?.formData?.produtorFonograficoFiliado || false,
      sociedadeEditor: props?.formData?.sociedadeEditor || "",
      sociedadeProdutor: props?.formData?.sociedadeProdutor || "",

      tipoFiliacao: props?.formData?.tipoFiliacao || "",

      unidadeAtendimento: props?.formData?.unidadeAtendimento || "",
      contatoAtendimento: props?.formData?.contatoAtendimento || "",
      comoConheceuUBC: props?.formData?.comoConheceuUBC || "",
      quemIndicouUBC: props?.formData?.quemIndicouUBC || "",
      impressao: props?.formData?.impressao || false,
    });

  const [validacao, setValidacao] = useState({
    sociedadeEditor: false,
    sociedadeProdutor: false,
    unidadeAtendimento: false,
    tipoFiliacao: false,

    naturezaFiliacao: false,
    compositor: true,
    produtor: true,

    territorioConexao: true,
    territorioAutoral: true,

  });

  useEffect(() => {
    validaForm();
    props.onChildDataChange(formData);
  }, [formData]);

  useEffect(() => {
    validaForm();
  }, []);

  const validaForm = () => {

    const validasociedadeEditor = !(formData.editorFiliado && formData.sociedadeEditor == '');
    const validasociedadeProdutor = !(formData.produtorFonograficoFiliado && formData.sociedadeProdutor == '');
    const validaSeNaturezaFiliacaoSelecionada = (formData.editor || formData.produtorFonograficoConexao)

    const validaCompositor = !formData.editor || (formData.editor && (formData.editorFiliado || formData.editorNaoFiliacao));
    const validaProdutor = !formData.produtorFonograficoConexao || (formData.produtorFonograficoConexao && (formData.produtorFonograficoFiliado || formData.produtorFonograficoNaoFiliacao));

    const validaTerritorioConexao = !(formData.editor && !formData.territorioAdmAutorais);
    const validaTerritorioAutoral = !((formData.produtorFonograficoConexao) && !formData.territorioAdmConexao);

    setValidacao((prevState) => {
      const updatedState = {
        ...prevState
      };

      updatedState.sociedadeEditor = validasociedadeEditor;
      updatedState.sociedadeProdutor = validasociedadeProdutor;
      updatedState.naturezaFiliacao = validaSeNaturezaFiliacaoSelecionada;
      updatedState.unidadeAtendimento = formData.unidadeAtendimento ? true : false;
      updatedState.tipoFiliacao = formData.tipoFiliacao ? true : false;

      updatedState.compositor = validaCompositor;
      updatedState.produtor = validaProdutor;

      updatedState.territorioConexao = validaTerritorioConexao;
      updatedState.territorioAutoral = validaTerritorioAutoral;

      return updatedState;
    });
  }

  const handleChange = (event) => {
    let { name, value, type, checked } = event.target;

    value = limiteTamanhoCampos(name, value);

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: type === 'checkbox' ? checked : value,
      };

      if (name === 'editor' && !checked) {
        updatedState.territorioAdmAutorais = '';
      }

      if ((name === 'produtorFonograficoConexao') && !checked) {
        updatedState.territorioAdmConexao = '';
      }

      if (name === 'editor' && !checked) {
        updatedState.editorNaoFiliacao = false;
        updatedState.editorFiliado = false;
        updatedState.sociedadeEditor = '';
      }

      if (name === 'produtorFonograficoConexao' && !checked) {
        updatedState.produtorFonograficoNaoFiliacao = false;
        updatedState.produtorFonograficoFiliado = false;
        updatedState.sociedadeProdutor = '';
      }

      if (name === 'produtorFonograficoConexao' && !checked) {
        updatedState.produtorFonograficoNaoFiliacao = false;
        updatedState.produtorFonograficoFiliado = false;
        updatedState.sociedadeProdutor = '';
      }

      if (name === 'editorFiliado' && !checked)
        updatedState.sociedadeEditor = '';

      if (name === 'produtorFonograficoFiliado' && !checked)
        updatedState.sociedadeProdutor = '';


      return updatedState;
    });
  };

  useImperativeHandle(ref, () => ({
    validarFormulario() {
      if (Object.values(validacao).some(value => !value)) {
        return false;
      }
      return true;
    },
    getDados() {
      return formData;
    }
  }));

  const cssQuebraPagina = { 'page-break-after': 'auto', 'break-after': 'page', 'width': '100%', 'position': 'relative' };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h5" gutterBottom strong>
        Natureza da filiação
      </Typography>
      <form>
        <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>

          <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
            <Grid>
              <Typography variant="body2">
                Titular de direitos autorais
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.editor}
                    onChange={handleChange}
                    name="editor"
                  />
                }
                label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Editor</span>}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.editor}
              error={formData.editor && !formData.territorioAdmAutorais}>
              <InputLabel>Território de Administração</InputLabel>
              <Select
                name="territorioAdmAutorais"
                value={formData.territorioAdmAutorais}
                onChange={handleChange}
                label="Território de Administração"
              >
                <MenuItem value="2136">Mundo</MenuItem>
                <MenuItem value="76">Brasil</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid>
              <Typography variant="body2">
                Titular de direitos conexo
              </Typography>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.produtorFonograficoConexao}
                      onChange={handleChange}
                      name="produtorFonograficoConexao"
                    />
                  }
                  label={<span style={{ color: !validacao.naturezaFiliacao ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal"
              disabled={!(formData.produtorFonograficoConexao)}
              error={(formData.produtorFonograficoConexao) && !formData.territorioAdmConexao}>
              <InputLabel>Território de Administração</InputLabel>
              <Select
                name="territorioAdmConexao"
                value={formData.territorioAdmConexao}
                onChange={handleChange}
                label="Território de Administração"
              >
                <MenuItem value="2136">Mundo</MenuItem>
                <MenuItem value="76">Brasil</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Declaração */}
          <Grid item xs={12} mt={2}>
            <Typography>
              <strong>Declaração:</strong> <br />
              Declaro que não sou filiado a nenhuma outra sociedade de direito autoral de
              execução pública nas categorias assinaladas abaixo, sendo a UBC a primeira sociedade a qual me filio.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.editorNaoFiliacao}
                    onChange={handleChange}
                    name="editorNaoFiliacao"
                  />
                }
                label={<span style={{ color: !validacao.compositor ? '#d32f2f' : '' }}>Editor</span>}
                disabled={!formData.editor || formData.editorFiliado}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.produtorFonograficoNaoFiliacao}
                    onChange={handleChange}
                    name="produtorFonograficoNaoFiliacao"
                  />
                }
                label={<span style={{ color: !validacao.produtor ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                disabled={!formData.produtorFonograficoConexao || formData.produtorFonograficoFiliado}
              />
            </FormControl>
          </Grid>

          {/* Declaração */}
          <Grid item xs={12} mt={2}>
            <Typography>
              <strong>Declaração:</strong> <br />
              Declaro que sou filiado a outra sociedade de direito autoral de
              execução pública nas categorias assinaladas abaixo, estou de acordo
              a me desligar dessa outra filiação.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.editorFiliado}
                    onChange={handleChange}
                    name="editorFiliado"
                  />
                }
                label={<span style={{ color: !validacao.compositor ? '#d32f2f' : '' }}>Editor</span>}
                disabled={!formData.editor || formData.editorNaoFiliacao}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.produtorFonograficoFiliado}
                    onChange={handleChange}
                    name="produtorFonograficoFiliado"
                  />
                }
                label={<span style={{ color: !validacao.produtor ? '#d32f2f' : '' }}>Produtor Fonográfico</span>}
                disabled={!formData.produtorFonograficoConexao || formData.produtorFonograficoNaoFiliacao}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>

            <Grid>
              <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.editorFiliado} error={!validacao.sociedadeEditor}>
                <InputLabel>Sociedade como Editor</InputLabel>
                <Select
                  name="sociedadeEditor"
                  value={formData.sociedadeEditor}
                  onChange={handleChange}
                  label="Sociedade como Editor"
                >
                  {sociedades.sort().map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" margin="normal" disabled={!formData.produtorFonograficoFiliado} error={!validacao.sociedadeProdutor}>
                <InputLabel>Sociedade como Produtor</InputLabel>
                <Select
                  name="sociedadeProdutor"
                  value={formData.sociedadeProdutor}
                  onChange={handleChange}
                  label="Sociedade como Produtor"
                >
                  {sociedades.map((item, index) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
              </FormControl>

            </Grid>
          </Grid>

          {/* Tipo de Filiação */}
          <div style={cssQuebraPagina}></div>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <FormControl component="fieldset" margin="normal" required
                error={!validacao.tipoFiliacao}>
                <FormLabel component="legend">Tipo de Filiação</FormLabel>
                <RadioGroup
                  name="tipoFiliacao"
                  value={formData.tipoFiliacao}
                  onChange={handleChange}
                  row
                >
                  <FormControlLabel value="nacional" control={<Radio />} label="Nacional" />
                  <FormControlLabel value="estrangeiro" control={<Radio />} label="Estrangeiro" />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>


          <Grid item xs={12} sm={6}>

            {!(props.finalizado || formData?.impressao) &&
              <FormControl fullWidth variant="outlined" margin="normal"
                required
                error={!validacao.unidadeAtendimento}>
                <InputLabel>Unidade de Atendimento</InputLabel>
                <Select
                  name="unidadeAtendimento"
                  value={formData?.unidadeAtendimento}
                  onChange={handleChange}
                  label="Unidade de Atendimento"
                >
                  {unidadesAtendimento.map((item) => (
                    <MenuItem key={item.id} value={item}>
                      {item.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
            {(props.finalizado || formData?.impressao) &&
              <TextField
                fullWidth
                label="Unidade de Atendimento"
                variant="outlined"
                margin="normal"
                name="contatoAtendimento"
                value={formData.unidadeAtendimento.nome}
              />
            }

          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contato do Atendimento"
              variant="outlined"
              margin="normal"
              name="contatoAtendimento"
              value={formData.contatoAtendimento}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel>Como conheceu a UBC?</InputLabel>
              <Select
                name="comoConheceuUBC"
                value={formData?.comoConheceuUBC}
                onChange={handleChange}
                label="Como conheceu a UBC?"
              >
                {listaComoConheceuUBC.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Quem te indicou para UBC?"
              variant="outlined"
              margin="normal"
              name="quemIndicouUBC"
              value={formData.quemIndicouUBC}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Campos marcados com * são obrigatórios.
          </Typography>
        </Box>

      </form>
    </Box>
  );
});

export default FormularioFiliacaoUBCPJ;
